import React, { Component } from 'react';
import ContentWrapper from '../../../components/Layout/ContentWrapper';

class BalanceCellFormatter extends Component {
  render() {
    const { dependentValues: { PreviousBalance, Amount, DiscountedAmount } } = this.props;
    const previousBalance = PreviousBalance || 0;
    const amount = Amount || 0;
    const discountedAmount = DiscountedAmount || 0;
    return (
      <ContentWrapper>
        {
          React.cloneElement(this.props.children, {
            value: (previousBalance - amount - discountedAmount).toFixed(2),
          })
        }
      </ContentWrapper>
    );
  }
}

export default BalanceCellFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/EditAP/balanceCellFormatter.jsx